module.exports = __webpack_public_path__ + "img/unionCode2.0474af24.png";